<template>

    <v-content>

        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <log></log>
    </v-content>
</template>

<script>
    import log from "./log";
    import { mapGetters } from "vuex";

    export default {
        name: 'ReportIndexList',
        watch: {},
        components: {
            log
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadCrumbs() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true

                    },
                    //{
                    //    text: 'Report  Dashboard',
                    //    disabled: false,
                    //    to: "/report",
                    //    exact: true

                    //},
                    {
                        text: this.$t('form_structures'),
                        disabled: true,
                    },
                ]
            },
            name() {
                return this.data;
            }
        },
        data() {
            return {
                
            };
        },
        mounted() {
           //this.loadData()
        },
        methods: {
            loadData() {
            //    this.breadCrumbs = [
            //        {
            //            text: 'Dashboard',
            //            disabled: false,
            //            to: `${this.usersData.dashBoard}`,
            //            exact: true

            //        },
            //        //{
            //        //    text: 'Report  Dashboard',
            //        //    disabled: false,
            //        //    to: "/report",
            //        //    exact: true

            //        //},
            //        {
            //            text: 'Form Structure',
            //            disabled: true,
            //        },
            //    ]
            },
            nullTitle( title ) {
                return title == null
            }
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>
